import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { inaccessibleComponentsSessionPagesAtom, inaccessibleLayoutSessionPagesAtom } from '../../../../../atoms/session-atoms';
import { usePanelStateAtom } from '../../../../../hooks/rules-state';
import { useGetRuleIds } from '../../../../../utils/get-rule-ids';
export const useGetPageRuleIds = (pageId, ruleIds) => {
  const {
    getGroupData,
    getPagesData
  } = usePanelStateAtom();
  const pagesData = getPagesData();
  const pageData = pagesData.get(pageId);
  const inaccessibleComponentsPages = useAtomValue(inaccessibleComponentsSessionPagesAtom);
  const inaccessibleLayoutPages = useAtomValue(inaccessibleLayoutSessionPagesAtom);
  const getRuleIds = useGetRuleIds();
  const ruleIdsToUse = useMemo(() => {
    return ((ruleIds == null ? void 0 : ruleIds.length) ?? 0) > 0 ? ruleIds : getRuleIds({
      getGroupData,
      inaccessibleComponentsPages,
      inaccessibleLayoutPages,
      pageData,
      pageId
    });
  }, [ruleIds, getRuleIds, getGroupData, inaccessibleComponentsPages, inaccessibleLayoutPages, pageData, pageId]);
  return ruleIdsToUse;
};
//# sourceMappingURL=use-get-page-rule-ids.js.map